import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaRemote, useMediaState } from "@vidstack/react";
import BasePlayerButton from "./BasePlayerButton";
const PlayButton = () => {
    const isPaused = useMediaState("paused");
    const remote = useMediaRemote();
    const icon = isPaused ? "play" : "pause";
    const label = isPaused ? "Executar" : "Pausar";
    return (_jsx(BasePlayerButton, { iconName: icon, label: label, onClick: (event) => {
            remote.togglePaused(event.nativeEvent);
        } }));
};
PlayButton.displayName = "PlayButton";
export default PlayButton;
